// Website content = UI strings (this file) + resume data generated from /resume.yaml.
// Do not edit resume text here: edit resume.yaml, then `npm start` / `npm run build` regenerates
// resume.json (portfolio/scripts/site-data.js -> tools/build_site_data.py).
import resume from "./resume.json";

// Styling only, keyed by the item ids in resume.yaml.
const icons = {
    "vision-dppo": { icon: "fas fa-helicopter", color: "from-violet-500 to-purple-600" },
    foodfate: { icon: "fas fa-utensils", color: "from-orange-400 to-red-500" },
    "factory-erp": { icon: "fas fa-industry", color: "from-blue-500 to-indigo-600" },
    "typing-practice": { icon: "fas fa-keyboard", color: "from-cyan-400 to-blue-500" },
    "coffee-map": { icon: "fas fa-map-marked-alt", color: "from-amber-400 to-orange-500" },
    bookkeeping: { icon: "fas fa-wallet", color: "from-emerald-400 to-teal-500" },
    notehub: { icon: "fas fa-book-open", color: "from-yellow-400 to-amber-500" },
    "itri-icl": { icon: "fas fa-shield-halved", color: "from-sky-500 to-blue-600" },
};
const DEFAULT_STYLE = { icon: "fas fa-code", color: "from-slate-500 to-gray-600" };
const awardIcons = {
    "most-research-scholarship": "fas fa-graduation-cap",
    "sos-ipo": "fas fa-trophy",
    "startup-showcase": "fas fa-medal",
};

const styled = (item) => ({ ...(icons[item.id] || DEFAULT_STYLE), ...item });

const ui = {
    en: {
        navbar: {
            home: "Home",
            experience: "Experience",
            projects: "Projects",
            publications: "Publications",
            awards: "Awards",
            resume: "Resume",
            menuOpen: "Open menu",
            menuClose: "Close menu",
        },
        greeting: (name) => `Hello, I'm ${name}`,
        actions: {
            viewProjects: "View Projects",
            resume: "Download Resume",
            email: "Email",
            linkedin: "LinkedIn",
            github: "GitHub",
        },
        titles: {
            about: "About Me",
            education: "Education",
            focus: "Focus Areas",
            skills: "Skills",
            stats: "By the Numbers",
            featured: "Featured Work",
            experience: "Experience",
            projects: "Projects",
            publications: "Publications",
            journals: "Journal Papers",
            conferences: "Conference Papers",
            awards: "Awards & Honors",
        },
        featuredActions: { experience: "Read more in Experience", project: "View Project" },
        projectActions: { view: "View Project", more: "Show more", less: "Show less" },
        footer: { separator: ". ", rights: "All Rights Reserved." },
    },
    zh: {
        navbar: {
            home: "首頁",
            experience: "經歷",
            projects: "專案",
            publications: "著作",
            awards: "獎項",
            resume: "履歷",
            menuOpen: "開啟選單",
            menuClose: "關閉選單",
        },
        greeting: (name) => `你好，我是${name} (Ben)`,
        actions: {
            viewProjects: "查看專案",
            resume: "下載履歷",
            email: "Email",
            linkedin: "LinkedIn",
            github: "GitHub",
        },
        titles: {
            about: "關於我",
            education: "學歷",
            focus: "專注領域",
            skills: "技能專長",
            stats: "數據亮點",
            featured: "精選作品",
            experience: "工作與研究經歷",
            projects: "專案作品",
            publications: "學術發表",
            journals: "期刊論文",
            conferences: "會議論文",
            awards: "獎項與榮譽",
        },
        featuredActions: { experience: "在經歷頁查看更多", project: "查看專案" },
        projectActions: { view: "查看專案", more: "顯示更多", less: "收合" },
        footer: { separator: "。", rights: "版權所有。" },
    },
};

// Builds the shape the pages expect (content.en / content.zh) from UI strings + resume data.
function build(lang) {
    const u = ui[lang];
    const r = resume[lang];
    return {
        navbar: u.navbar,
        hero: {
            greeting: u.greeting(r.name),
            titles: r.heroTitles,
            tagline: r.seeking,
            actions: u.actions,
        },
        about: {
            title: u.titles.about,
            description: r.about,
            education: { title: u.titles.education, items: r.education },
            focus: { title: u.titles.focus, items: r.focusAreas },
        },
        skills: { title: u.titles.skills, groups: r.skills },
        stats: { title: u.titles.stats, items: r.stats },
        featured: { title: u.titles.featured, actions: u.featuredActions },
        experience: { title: u.titles.experience, items: r.experience.map(styled) },
        projects: { title: u.titles.projects, actions: u.projectActions, items: r.projects.map(styled) },
        publications: {
            title: u.titles.publications,
            journalTitle: u.titles.journals,
            conferenceTitle: u.titles.conferences,
            journals: r.publications.journals,
            conferences: r.publications.conferences,
        },
        awards: {
            title: u.titles.awards,
            items: r.awards.map((a) => ({ ...a, icon: awardIcons[a.id] || "fas fa-award" })),
        },
        footer: { ...u.footer, name: r.name },
    };
}

export const content = { en: build("en"), zh: build("zh") };

// Home "Featured Work": picked by id so reordering content.items can't silently
// swap what's featured. type selects the list: experience.items or projects.items.
export const featuredWork = [
    { type: "experience", id: "itri-icl" },
    { type: "project", id: "vision-dppo" },
];

export function resolveFeatured(t) {
    return featuredWork
        .map(({ type, id }) => {
            const list = type === "experience" ? t.experience.items : t.projects.items;
            const item = list.find((entry) => entry.id === id);
            return item ? { type, item } : null;
        })
        .filter(Boolean);
}
